module.exports = __webpack_public_path__ + "media/images/icons/spotify-podcast-5a72b744c5702faea2fad14b5ad7e512.svg";